import Typography from '@mui/material/Typography'

export const TagHelpText = () => (
  <Typography
    variant="caption"
    color="text.secondary"
    display="block"
    gutterBottom
  >
    Tag names can contain letters, numbers, spaces and the following special
    characters: apostrophe (&apos;), dash (-), underscore (_) and ampersand (&)
  </Typography>
)

export const PopperModifiers = () => [
  {
    name: 'offset',
    options: {
      offset: [0, 10],
    },
  },
]
